import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IQueryParams } from '@portal/shared/ui/table';
import { ISearchBoxValue, ISelectInput, SearchOperator } from '@portal/shared/ui/filter';
import orderBy from 'lodash-es/orderBy';
import { SearchSelector } from '@portal/entity-services/organisations/src/lib/enums/search-selector.enum';
import { Subject } from 'rxjs';
import isEmpty from 'lodash-es/isEmpty';

@Component({
    selector: 'portal-filter-organisation-group',
    templateUrl: './filter.component.html',
    standalone: false
})
export class FilterOrganisationGroupComponent {
  @Input()
  filter: IQueryParams;

  @Input()
  filterTouched: boolean;

  @Output()
  nameFiltered: EventEmitter<ISearchBoxValue> = new EventEmitter();

  @Output()
  orgsFilterReset: EventEmitter<void> = new EventEmitter();

  @Output()
  orgsFilterChanged: EventEmitter<string> = new EventEmitter();

  @Output()
  searchUpdated: EventEmitter<ISelectInput> = new EventEmitter();

  searchEntities: ISelectInput[] = orderBy(
    [
      {
        id: SearchSelector.Name,
        text: $localize`:Search criteria in Organisation Group list:Group name`,
      },
    ],
    'text',
  );

  searchTerm: Subject<string> = new Subject();
  selectedSearchSelector: Subject<string> = new Subject();
  organisationIdSearchSelected = false;
  entityNameSelector = SearchSelector.Name;

  resetEntity$ = new Subject();

  isKnownSearchEntity(entityKey: string): boolean {
    return this.searchEntities.some((entity: ISelectInput) => {
      return entity.id === entityKey;
    });
  }

  onOrganisationSearched(input: ISearchBoxValue): void {
    // Check for an unknown search entity.
    if (!this.isKnownSearchEntity(input?.key)) {
      return;
    }

    if (isEmpty(input.value)) {
      this.orgsFilterChanged.emit(input.key);
      this.nameFiltered.emit();
    } else {
      this.nameFiltered.emit({
        key: input.key,
        value: input.value,
        operator: SearchOperator.Equal,
      });
    }
  }

  resetFilter(): void {
    this.searchTerm.next('');
    this.orgsFilterReset.emit();
    this.orgsFilterChanged.emit();
    this.nameFiltered.emit();
    this.resetEntity$.next();
  }

  onSearchEntityRemoved(key: string): void {
    this.orgsFilterChanged.emit(key);
  }

  searchBoxInitComplete(): void {
    this.searchEntities.forEach((entity) => {
      if (this.filter.searchCriteria.has(entity.id)) {
        this.selectedSearchSelector.next(entity.id);
        this.searchTerm.next(this.filter.searchCriteria.get(entity.id).argument);
      }
    });
  }

  onSearchUpdated(searchInput: ISelectInput): void {
    this.organisationIdSearchSelected = searchInput.key === SearchSelector.EntityId;
    this.searchUpdated.emit(searchInput);
  }
}
